import { DefaultTheme } from 'styled-components'

/**
 * 通常テーマ
 */
export const defaultTheme: DefaultTheme = {
    borders: {
        normal: '1px solid #ababab',
        thick: '1.2px solid #808080',
    },
    colors: {
        fore: '#404040',

        bg: '#ddd',
        bgMain: '#f5f5f5',
        bgSub: '#eaeaea',
        bgActive: '#2f73c355',
        bgPrimary: '#9cceeb',

        darkLine: '#707070',
        borderLine: '#c7c7c7',

        bgDisabled: '#c7c7c7',
        bgInfo: '#76B8DB',

        bgFooter: '#4B4949',
    },
    sizes: {
        main: '12px',
        small: '9px',

    },
    spaces: {
        large: '30px',
        normal: '15px',

        section: '50px',
    }
}
